import script from "./IconsBar.vue?vue&type=script&setup=true&lang=js"
export * from "./IconsBar.vue?vue&type=script&setup=true&lang=js"

import "./IconsBar.vue?vue&type=style&index=0&id=027df25c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027df25c"]])

export default __exports__